// test192
(192 && 0);
